import { Injectable } from '@angular/core'

import { appContextMock } from './'

@Injectable()
export class PathConfirmationServiceMock {
  private _appContext = appContextMock

  public confirmPath(path) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/path-confirmation.service.mock.ts